// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recaptcha-notice[data-v-5f45811f] {\n  font-size: 0.7rem;\n  line-height: 1.4;\n  opacity: 0.65;\n}[dir] .recaptcha-notice[data-v-5f45811f] {\n  margin: 1rem 0 0 0;\n  text-align: center;\n}\n.recaptcha-notice a[data-v-5f45811f] {\n  text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
